export default {
  // Get all coupons
  GET_COUPONS_BEGIN(state) {
    state.isLoading = true;
    state.error = null;
  },
  GET_COUPONS_SUCCESS(state, data) {
    state.isLoading = false;
    state.coupons = data;
    state.totalCoupons = data.length;
    state.error = null;
  },
  GET_COUPONS_ERR(state, err) {
    state.isLoading = false;
    state.error = err;
    state.coupons = [];
    state.totalCoupons = 0;
  },

  // Get single coupon
  GET_COUPON_BEGIN(state) {
    state.isCouponLoading = true;
    state.error = null;
  },
  GET_COUPON_SUCCESS(state, data) {
    state.isCouponLoading = false;
    state.coupon = data;
    state.error = null;
  },
  GET_COUPON_ERR(state, err) {
    state.isCouponLoading = false;
    state.error = err;
    state.coupon = null;
  },

  // Create coupon
  CREATE_COUPON_BEGIN(state) {
    state.isLoading = true;
    state.error = null;
  },
  CREATE_COUPON_SUCCESS(state) {
    state.isLoading = false;
    state.error = null;
    // Coupon will be added to the list when getAllCoupons is called
  },
  CREATE_COUPON_ERR(state, err) {
    state.isLoading = false;
    state.error = err;
  },

  // Update coupon
  UPDATE_COUPON_BEGIN(state) {
    state.isLoading = true;
    state.error = null;
  },
  UPDATE_COUPON_SUCCESS(state, data) {
    state.isLoading = false;
    state.error = null;
    // Update the coupon in the state
    const index = state.coupons.findIndex(coupon => coupon.id === data.id);
    if (index !== -1) {
      state.coupons.splice(index, 1, data);
    }
  },
  UPDATE_COUPON_ERR(state, err) {
    state.isLoading = false;
    state.error = err;
  },

  // Delete coupon
  DELETE_COUPON_BEGIN(state) {
    state.isLoading = true;
    state.error = null;
  },
  DELETE_COUPON_SUCCESS(state, couponId) {
    state.isLoading = false;
    state.error = null;
    // Remove the coupon from the state
    state.coupons = state.coupons.filter(coupon => coupon.id !== couponId);
    state.totalCoupons = state.coupons.length;
  },
  DELETE_COUPON_ERR(state, err) {
    state.isLoading = false;
    state.error = err;
  },

  // Search coupons
  SEARCH_COUPONS_BEGIN(state) {
    state.isLoading = true;
    state.error = null;
  },
  SEARCH_COUPONS_SUCCESS(state, data) {
    state.isLoading = false;
    state.searchResults = data;
    state.error = null;
  },
  SEARCH_COUPONS_ERR(state, err) {
    state.isLoading = false;
    state.error = err;
    state.searchResults = [];
  },

  // Get usage history
  GET_USAGE_HISTORY_BEGIN(state) {
    state.isUsageHistoryLoading = true;
    state.error = null;
  },
  GET_USAGE_HISTORY_SUCCESS(state, data) {
    state.isUsageHistoryLoading = false;
    state.usageHistory = data;
    state.error = null;
  },
  GET_USAGE_HISTORY_ERR(state, err) {
    state.isUsageHistoryLoading = false;
    state.error = err;
    state.usageHistory = [];
  },

  // Validate coupon
  VALIDATE_COUPON_BEGIN(state) {
    state.isLoading = true;
    state.error = null;
  },
  VALIDATE_COUPON_SUCCESS(state) {
    state.isLoading = false;
    state.error = null;
  },
  VALIDATE_COUPON_ERR(state, err) {
    state.isLoading = false;
    state.error = err;
  },

  // Apply coupon
  APPLY_COUPON_BEGIN(state) {
    state.isLoading = true;
    state.error = null;
  },
  APPLY_COUPON_SUCCESS(state) {
    state.isLoading = false;
    state.error = null;
  },
  APPLY_COUPON_ERR(state, err) {
    state.isLoading = false;
    state.error = err;
  },

  // Filter coupons
  FILTER_COUPONS_BEGIN(state) {
    state.isLoading = true;
    state.error = null;
  },
  FILTER_COUPONS_SUCCESS(state, data) {
    state.isLoading = false;
    state.searchResults = data;
    state.error = null;
  },
  FILTER_COUPONS_ERR(state, err) {
    state.isLoading = false;
    state.error = err;
    state.searchResults = [];
  },

  // Clear search results
  CLEAR_SEARCH(state) {
    state.searchResults = [];
  },

  // Clear error
  CLEAR_ERROR(state) {
    state.error = null;
  },

  // Set loading state
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },

  // Set coupon loading state
  SET_COUPON_LOADING(state, isLoading) {
    state.isCouponLoading = isLoading;
  },

  // Set usage history loading state
  SET_USAGE_HISTORY_LOADING(state, isLoading) {
    state.isUsageHistoryLoading = isLoading;
  }
};
